"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgDashboardViewOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M11.49 16v2A1.5 1.5 0 1110 19.5H8a3.5 3.5 0 103.5-3.5z" }),
        React.createElement("path", { d: "M3 3v26h26V3zm24 7H14V5h13zM12 5v5H5V5zM5 27V12h22v15z" }),
        React.createElement("path", { d: "M17.99 16h2v7h-2zM21.99 19h2v4h-2z" })));
}
exports.default = SvgDashboardViewOutline;
//# sourceMappingURL=DashboardViewOutline.js.map